import { Item } from "../../typings/miro";
import { ItemType } from "../../typings/miroEnums";

export function duplicateProps(item: Item) {
    let itemProps: any = { type: item.type };
    const _item = item as { [key: string]: any }

    // add in any applicable props from the original that are writeable
    for (const prop of Object.getOwnPropertyNames(item)) {
        if (Object.getOwnPropertyDescriptor(item, prop)?.writable) {
            itemProps[prop] = _item[prop];
        }
    }

    //exception for Sticky Notes can't have both height and width
    if (item.type === ItemType.StickyNote && "width" in itemProps && "height" in itemProps) {
        delete itemProps.height;
    }

    return itemProps;
}
